module.exports = __webpack_public_path__ + "static/media/ZON1-NEW.e74065e7.apng";